export default class PostcodeService {
  /* @ngInject */
  constructor(NetworkService, $timeout) {
    this.NetworkService = NetworkService;
    this.timeout = $timeout;
  }

  getPostCode(postCode) {
    this.NetworkService.loading = true;
    return this.timeout(() => this.networkServiceRequest(postCode), 1000);
  }

  networkServiceRequest(postCode) {
    return this.NetworkService.getPostCode(postCode);
  }
}



// WEBPACK FOOTER //
// ./src/services/postCode.service.js